import {
  ImportControlModeTemplateErrorDto,
  ValidationErrorItem,
} from '@src/types/ControlModes';

export interface UseTemplateValidationResult {
  validateTemplate: (data: unknown) => Promise<boolean>;
  validateTemplateFile: (file: File) => Promise<boolean>;
  isValidating: boolean;
  error: ImportControlModeTemplateErrorDto | null;
  resetError: () => void;
}

export interface PathSegmentResult {
  humanPart: string;
  nextObject: Record<string, unknown> | unknown[] | undefined;
}

export interface ArrayProcessorConfig<T> {
  hasArrayGuard: (obj: unknown) => obj is T;
  arrayProperty?: string;
  hasNameGuard: (item: unknown) => boolean;
  getName: (item: unknown) => string;
  prefix: string;
}

export interface PathProcessorConfig {
  arrayProcessors: Record<
    string,
    (
      currentObject: Record<string, unknown> | unknown[],
      index: number,
      arrayName?: string,
    ) => PathSegmentResult
  >;
  defaultArrayProcessor: (
    currentObject: Record<string, unknown> | unknown[],
    arrayName: string,
    index: number,
  ) => PathSegmentResult;
  propertyProcessor: (
    segment: string,
    currentObject: Record<string, unknown> | unknown[],
  ) => PathSegmentResult;
}

export enum ErrorType {
  VALIDATION = 'validation',
  JSON_PARSING = 'json_parsing',
  FILE_READING = 'file_reading',
  GENERIC = 'generic',
}

export interface ErrorConfig {
  type: ErrorType;
  title: string;
  getDetails: (err?: unknown, data?: unknown) => string | ValidationErrorItem[];
}
